module.exports = __webpack_public_path__ + "img/1950-CBM.794c7138.png";